import {Button, Dropdown, Modal} from "antd";
import {EllipsisOutlined, EyeOutlined} from "@ant-design/icons";
import {useTranslation} from "react-i18next";

export default function RequestLogRowMenu({row}) {
    const {t} = useTranslation();

    const showDetail = () => {
        Modal.info({
            title: t('Request Detail'),
            width: '80%',
            content: (
                <div style={{maxHeight: '60vh', overflow: 'auto'}}>
                    <div style={{marginBottom: 16}}>
                        <strong>{t('User')}:</strong> {row.userName || '-'}<br/>
                        <strong>{t('App Client')}:</strong> {row.appClientName || '-'}<br/>
                        <strong>{t('IP')}:</strong> {row.ipAddress || '-'}<br/>
                        <strong>{t('Method')}:</strong> {row.httpMethod}<br/>
                        <strong>{t('Path')}:</strong> {row.path}<br/>
                        {row.queryString && <><strong>{t('Query')}:</strong> {row.queryString}<br/></>}
                        <strong>{t('Status')}:</strong> {row.statusCode}<br/>
                        <strong>{t('Time')}:</strong> {row.elapsedMs}ms<br/>
                        <strong>{t('Login Attempt')}:</strong> {row.isLoginAttempt ? t('Yes') : t('No')}<br/>
                        {row.isLoginAttempt && <><strong>{t('Failed Login')}:</strong> {row.isFailedLogin ? t('Yes') : t('No')}<br/></>}
                    </div>
                    {row.requestBody && (
                        <>
                            <strong>{t('Request Body')}:</strong>
                            <pre style={{
                                backgroundColor: '#f5f5f5',
                                padding: 16,
                                borderRadius: 4,
                                fontSize: 12,
                                whiteSpace: 'pre-wrap',
                                wordBreak: 'break-all',
                                marginTop: 8
                            }}>
                                {(() => {
                                    try {
                                        return JSON.stringify(JSON.parse(row.requestBody), null, 2);
                                    } catch {
                                        return row.requestBody;
                                    }
                                })()}
                            </pre>
                        </>
                    )}
                </div>
            ),
            okText: t('Close'),
        });
    }

    const items = [
        {
            key: 'detail',
            label: t('View Detail'),
            icon: <EyeOutlined />,
            onClick: showDetail
        },
    ];

    return (
        <Dropdown menu={{items}} trigger={['click']}>
            <Button size="small" icon={<EllipsisOutlined />}>
                {row.id?.substring(0, 8)}...
            </Button>
        </Dropdown>
    );
}
